// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zfrvg","label":"styles_label__fr7kt"};